// import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';
// import { getPetList, createPet, updatePet } from '~/services/common';
// import type { DefaultRequest, PetCreateRequest, PetUpdateRequest } from '~/types/common';

import { useQuery } from "@tanstack/react-query";
import { DefaultPetRequest, PetCalendarList } from "~/types/common";
import { useAuth } from "./useAuth";
import { setAuthToken } from "~/config/axios";
import { useEffect } from "react";
import {
  getPetList,
  getPetScheduleList,
  getPetcalendarList,
} from "~/services/customer/common";

// Query Keys
export const PET_QUERY_KEYS = {
  list: ["pet", "list"],
} as const;

// interface PetOption {
//     label: string;
//     value: number;
// }

export const usePet = () => {
  const { getToken } = useAuth();

  // 컴포넌트 마운트 시 토큰 설정
  useEffect(() => {
    const token = getToken();
    setAuthToken(token);
  }, [getToken]);

  // 반려동물 목록 조회 query
  const usePetList = () => {
    return useQuery({
      queryKey: [...PET_QUERY_KEYS.list],
      queryFn: () => getPetList(),
      // select: (data) => {
      //   // 데이터를 label과 value 형태로 변환
      //   return data.map((pet: any) => ({
      //     label: pet.petName,
      //     value: pet.petSeq.toString(),
      //   }));
      // },
    });
  };

  const usePetCalendarList = (request: PetCalendarList) => {
    return useQuery({
      queryKey: [...PET_QUERY_KEYS.list, request],
      queryFn: () => getPetcalendarList(request),
      enabled: !!request.petSeq && request.petSeq !== "", // petSeq가 존재하고 빈 문자열이 아닐 때만 API 호출
    });
  };

  const usePetScheduleList = (request: DefaultPetRequest) => {
    return useQuery({
      queryKey: [...PET_QUERY_KEYS.list, request],
      queryFn: () => getPetScheduleList(request),
      enabled: !!request.petSeq && request.petSeq !== "",
    });
  };
  // // 반려동물 추가
  // const { mutate: addPet, isPending: isAdding } = useMutation({
  //     mutationFn: (petData: PetCreateRequest) => createPet(petData),
  //     onSuccess: () => {
  //         queryClient.invalidateQueries({ queryKey: PET_QUERY_KEYS.list });
  //     },
  // });

  // 반려동물 수정
  // const { mutate: updatePet, isPending: isUpdating } = useMutation({
  //     mutationFn: (petData: PetUpdateRequest) => updatePet(petData),
  //     onSuccess: () => {
  //         queryClient.invalidateQueries({ queryKey: PET_QUERY_KEYS.list });
  //     },
  // });

  return {
    usePetList,
    usePetCalendarList,
    usePetScheduleList,
    // addPet,
    // isAdding,
    // updatePet,
    // isUpdating,
  };
};
